// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"e3660db3","36":"00f873ea","222":"3d087eaa","231":"b5a5aca0","318":"25e00006","371":"b26a9ace","423":"8d559e42","465":"dec100d8","569":"6c3f3e98","732":"19279cd5"}[chunkId] + ".chunk.js";
};